import React, { useEffect, useState, useCallback } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const GNBPURE03002S = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const newsNo = params.get("news_no");                   // URL에서 empt_no 파라미터를 가져옴

    const { doAction } = useApplicationCommon();            // ✅ `doAction`만 사용
    const [isDepthOpen, setIsDepthOpen] = useState(false);  // depth2 메뉴 열림 상태
    const [newsDetail, setNewsDetail] = useState([]);       // 소식 리스트
    const [newsContent, setNewsContent] = useState("");     // 소식 내용 저장

    // ✅ 소식 상세 조회
    const goSearch = () => {
        const actionForm = {
            txGbnCd: "srchDetail",
            newsNo: newsNo,
        };

        doAction("COM0000SC", actionForm, (resData) => {
            if (resData.APP_HEADER.respCd === "N00001") {
                setNewsDetail(resData);
                
                const newsCntnElement = resData.news_cntn;
                if (newsCntnElement) {
                    setNewsContent(newsCntnElement);
                }
            }
        });
    }

    // ✅ html 변경
    const decodeEntities = (encodedString) => {
        const textArea = document.createElement("textarea");
        textArea.innerHTML = encodedString;
        return textArea.value;
    };

    const memoizedGoSearch = useCallback(goSearch, []);
        // ✅ 최초 조회
        useEffect(() => {
            if (newsNo) {
                goSearch(newsNo);
            }
        }, [memoizedGoSearch]);

    return (
        <CommonLayout>
            <CommonMenu/>

            <div id="contents" class="container">
                <input type="hidden" id="news_cntn" name="news_cntn" value={newsDetail.news_cntn}/>
                <div class="sub-title bg-type04">
                    <h2>우리회사소식</h2>	
                </div>

                <div class="location_wrap">
                    <ul class="depth1">
                        <li><a href="/">home</a></li>
                        <li><a href="/GNBPURE03001S">우리회사소식<span></span></a>
                            <ul class="depth2">
                                <li><Link to="/GNBPURE00000S">CEO인사말</Link></li>
                                <li><Link to="/GNBPURE00001S">ABOUT US</Link></li>
                                <li><Link to="/GNBPURE03001S">우리회사소식</Link></li>
                                <li><Link to="/GNBPURE00002S">사업실적</Link></li>
                                <li><Link to="/GNBPURE00003S">오시는길</Link></li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div id="cont" class="cont">
                    <div class="inner">
                        <h3>우리회사소식</h3>
                        
                        <dl class="board-wrap board-view">
                            <dt><p>{newsDetail.news_ttl}</p><span>{newsDetail.rg_dtm}</span></dt>
                            <dd id="news_cntn_view" dangerouslySetInnerHTML={{ __html: decodeEntities(newsContent) }}></dd>
                        </dl>

                        <ul class="btn-wrap">
                            <li><a href="/GNBPURE03001S" class="btn btn-primary">목록</a></li>
                        </ul>

                    </div>
                </div>
            </div>
            <CommonFooter/>
        </CommonLayout>
    );
}

export default GNBPURE03002S;